import { Box, Button, Paper, Popover, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, IconButton, MenuItem, ListItemIcon, ListItemText, CircularProgress, Checkbox, Card, CardHeader, CardContent } from "@mui/material"
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Layout from "../components/Layout"
import { useEffect, useState, useCallback } from "react"
import { PetModal } from "../components/PetModal"
import { useForm, Controller } from "react-hook-form"
import { toast } from "react-toastify"
import { userAPI } from "../api/userAPI"
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import ConfirmButton from "../components/ConfirmButton";
import { Container } from '../components/Container';
import { IMaskInput } from "react-imask";
import { FilterUsers } from "../components/FilterUsers";

export const Users = () => {

    const [rows, setRows] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
    const [openModalUserEdit, setOpenModalUserEdit] = useState(false);
    const [loading, setLoading] = useState({
        create: false,
        edit: false,
        delete: false,
        loadData: false
    });

    const loadData = useCallback(async (data) => {
        setLoading(prev => ({ ...prev, loadData: true }));
        const response = await userAPI.getUsers(data);
        if (response.success) {
            setRows(response.data.users || []);
        } else {
            toast.error(response.message || "Erro ao carregar dados")
        }
        setLoading(prev => ({ ...prev, loadData: false }));
    }, []);

    useEffect(() => {
        loadData();
    }, [loadData]);

    const [openModalUser, setOpenModalUser] = useState(false)
    const defaultValues = {
        name: '',
        email: '',
        phone: '',
        document: '',
        password: '',
        isActive: true
    }

    const methods = useForm({ defaultValues })

    const handleClick = (event, user) => {
        setAnchorEl(event.currentTarget);
        setSelectedUser(user);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setSelectedUser(null);
    };

    const handleEditUser = async (user) => {
        setLoading({ ...loading, edit: true });
        const response = await userAPI.getUserById(user.id);
        if (response.success) {
            methods.reset({
                id: response.data.user.id,
                name: response.data.user.name,
                email: response.data.user.email,
                phone: response.data.user.phone,
                document: response.data.user.document,
                isActive: response.data.user.active,
                password: ''
            });
        } else {
            toast.error(response.message);
        }
        setOpenModalUserEdit(true);
        setLoading({ ...loading, edit: false });
    }

    const handleDeleteUser = async (user) => {
        setLoading({ ...loading, delete: true });
        const result = await userAPI.deleteUser(user.id);
        if (result.success) {
            toast.success(result.message);
            loadData();
            handleClose();
        } else {
            toast.error(result.message || 'Erro ao excluir usuário');
        }
        setLoading({ ...loading, delete: false });
    }


    async function submitCreate(data) {
        setLoading({ ...loading, create: true });
        const body = {
            name: data.name,
            email: data.email,
            phone: data.phone,
            document: data.document,
            password: data.password,
            isActive: data.isActive
        }
        const response = await userAPI.createUser(body);
        if (response.success) {
            toast.success(response.message);
            setOpenModalUser(false);
            methods.reset(defaultValues);
            loadData();
        } else {
            toast.error(response.message)
        }
        setLoading({ ...loading, create: false });
    }

    async function submitEditUser(data) {
        setLoading({ ...loading, edit: true });
        const body = { ...data };
        if (!body.password) {
            delete body.password;
        }
        const response = await userAPI.updateUser(data.id, body);
        if (response.success) {
            toast.success(response.message);
            setOpenModalUserEdit(false);
            methods.reset(defaultValues);
            loadData();
        } else {
            toast.error(response.message);
        }
        setLoading({ ...loading, edit: false });
    }

    const openModalNewUser = () => {
        setOpenModalUser(true);
        methods.reset(defaultValues);
    }

    return (
        <>
            <PetModal
                open={openModalUser}
                onClose={() => setOpenModalUser(false)}
                title="Novo Usuário"
                size={'small'}
                formId='user-form'
                loading={loading.create}
            >
                <form id='user-form' onSubmit={methods.handleSubmit(submitCreate)}>
                    <Box display='flex' flexDirection='column' className='gap-1'>
                        <Controller
                            name="name"
                            control={methods.control}
                            rules={{ required: "Nome é obrigatório" }}
                            render={({ field, fieldState: { error } }) => (
                                <TextField
                                    {...field}
                                    id="outlined-basic"
                                    label="Nome"
                                    variant="outlined"
                                    error={!!error}
                                    helperText={error?.message}
                                    InputLabelProps={{ shrink: !!field.value }}
                                />
                            )}
                        />
                        <Controller
                            name="email"
                            control={methods.control}
                            rules={{ required: "Email é obrigatório" }}
                            render={({ field, fieldState: { error } }) => (
                                <TextField
                                    {...field}
                                    id="outlined-basic"
                                    label="Email"
                                    variant="outlined"
                                    type="email"
                                    error={!!error}
                                    helperText={error?.message}
                                    InputLabelProps={{ shrink: !!field.value }}
                                />
                            )}
                        />
                        <Controller
                            name="phone"
                            control={methods.control}
                            rules={{ required: "Telefone é obrigatório" }}
                            render={({ field: { ref, ...field }, fieldState: { error } }) => (
                                <TextField
                                    {...field}
                                    id="outlined-basic"
                                    label="Telefone"
                                    variant="outlined"
                                    type="tel"
                                    inputRef={ref}
                                    error={!!error}
                                    helperText={error?.message}
                                    InputProps={{
                                        inputComponent: IMaskInput,
                                    }}
                                    inputProps={{
                                        mask: "(00)00000-0000"
                                    }}
                                    InputLabelProps={{ shrink: !!field.value }}
                                />
                            )}
                        />
                        <Controller
                            name="document"
                            control={methods.control}
                            rules={{ required: "Documento é obrigatório" }}
                            render={({ field: { ref, ...field }, fieldState: { error } }) => (
                                <TextField
                                    {...field}
                                    id="outlined-basic"
                                    label="Documento"
                                    variant="outlined"
                                    type="text"
                                    inputRef={ref}
                                    error={!!error}
                                    helperText={error?.message}
                                    InputProps={{
                                        inputComponent: IMaskInput,
                                    }}
                                    inputProps={{
                                        mask: "000.000.000-00"
                                    }}
                                    InputLabelProps={{ shrink: !!field.value }}
                                />
                            )}
                        />
                        <Controller
                            name="password"
                            control={methods.control}
                            rules={{ required: "Senha é obrigatória" }}
                            render={({ field, fieldState: { error } }) => (
                                <TextField
                                    {...field}
                                    id="outlined-basic"
                                    label="Senha"
                                    variant="outlined"
                                    type="password"
                                    error={!!error}
                                    helperText={error?.message}
                                    InputLabelProps={{ shrink: !!field.value }}
                                />
                            )}
                        />
                        <Controller
                            name="isActive"
                            control={methods.control}
                            render={({ field }) => (
                                <Box display='flex' flexDirection='row' className='gap-1' alignItems='center'>
                                    <Checkbox
                                        {...field}
                                        checked={field.value}
                                    />
                                    <Typography>Ativo</Typography>
                                </Box>
                            )}
                        />
                    </Box>
                </form>
            </PetModal>
            <PetModal
                open={openModalUserEdit}
                onClose={() => setOpenModalUserEdit(false)}
                title="Editar Usuário"
                size={'small'}
                formId='user-form-edit'
                loading={loading.edit}
            >
                <form id='user-form-edit' onSubmit={methods.handleSubmit(submitEditUser)}>
                    <Box display='flex' flexDirection='column' className='gap-1'>
                        <Controller
                            name="name"
                            control={methods.control}
                            render={({ field }) => (
                                <TextField
                                    {...field}
                                    id="outlined-basic"
                                    label="Nome"
                                    variant="outlined"
                                    InputLabelProps={{ shrink: !!field.value }}
                                />
                            )}
                        />
                        <Controller
                            name="email"
                            control={methods.control}
                            rules={{ required: "Email é obrigatório" }}
                            render={({ field, fieldState: { error } }) => (
                                <TextField
                                    {...field}
                                    id="outlined-basic"
                                    label="Email"
                                    variant="outlined"
                                    type="email"
                                    error={!!error}
                                    helperText={error?.message}
                                    InputLabelProps={{ shrink: !!field.value }}
                                />
                            )}
                        />
                        <Controller
                            name="phone"
                            control={methods.control}
                            rules={{ required: "Telefone é obrigatório" }}
                            render={({ field: { ref, ...field }, fieldState: { error } }) => (
                                <TextField
                                    {...field}
                                    id="outlined-basic"
                                    label="Telefone"
                                    variant="outlined"
                                    type="tel"
                                    inputRef={ref}
                                    error={!!error}
                                    helperText={error?.message}
                                    InputProps={{
                                        inputComponent: IMaskInput,
                                    }}
                                    inputProps={{
                                        mask: "(00)00000-0000"
                                    }}
                                    InputLabelProps={{ shrink: !!field.value }}
                                />
                            )}
                        />
                        <Controller
                            name="document"
                            control={methods.control}
                            rules={{ required: "Documento é obrigatório" }}
                            render={({ field: { ref, ...field }, fieldState: { error } }) => (
                                <TextField
                                    {...field}
                                    id="outlined-basic"
                                    label="Documento"
                                    variant="outlined"
                                    type="text"
                                    inputRef={ref}
                                    error={!!error}
                                    helperText={error?.message}
                                    InputProps={{
                                        inputComponent: IMaskInput,
                                    }}
                                    inputProps={{
                                        mask: "000.000.000-00"
                                    }}
                                    InputLabelProps={{ shrink: !!field.value }}
                                />
                            )}
                        />
                        <Controller
                            name="password"
                            control={methods.control}
                            render={({ field }) => (
                                <TextField
                                    {...field}
                                    id="outlined-basic"
                                    label="Senha"
                                    variant="outlined"
                                    type="password"
                                    InputLabelProps={{ shrink: !!field.value }}
                                />
                            )}
                        />
                        <Controller
                            name="isActive"
                            control={methods.control}
                            render={({ field }) => (
                                <Box display='flex' flexDirection='row' className='gap-1' alignItems='center'>
                                    <Checkbox
                                        {...field}
                                        checked={field.value}
                                    />
                                    <Typography>Ativo</Typography>
                                </Box>
                            )}
                        />
                    </Box>
                </form>
            </PetModal>


            <Layout height="calc(100vh - 100px)">
                <Box marginBottom='10px'>
                    <Typography variant="h4" component="h1" color="primary">
                        Usuários
                    </Typography>
                </Box>

                <Box marginBottom="10px" width="100%" display="flex" justifyContent="flex-end" className="gap-1">
                    <Button
                        style={{ textTransform: "none" }}
                        color="primary"
                        variant="contained"
                        onClick={() => openModalNewUser()}
                        disabled={loading.create}
                    >
                        <Typography>
                            Novo Usuário
                        </Typography>
                    </Button>
                    <FilterUsers onFilter={loadData} />
                </Box>

                <Box display={{ xs: 'block', sm: 'none' }}>
                    {loading.loadData ? (
                        <Box display='flex' justifyContent='center' alignItems='center' height='100%'>
                            <CircularProgress size={20} />
                        </Box>
                    ) : rows.length === 0 ? (
                        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="200px" sx={{ color: '#9CA3AF' }}>
                            <Typography variant="body1" color="textSecondary">
                                Nenhum usuário encontrado
                            </Typography>
                        </Box>
                    ) : (
                        rows.map((row) => (
                            <Card key={row.id} sx={{ mb: 2, borderRadius: 2, boxShadow: 3 }}>
                                <CardHeader
                                    title={
                                        <Typography variant="subtitle1" fontWeight={600}>
                                            {row.name}
                                        </Typography>
                                    }
                                    action={
                                        <IconButton
                                            onClick={(event) => handleClick(event, row)}
                                            size="small"
                                        >
                                            <MoreHorizIcon />
                                        </IconButton>
                                    }
                                />
                                <CardContent>
                                    <Box display="flex" alignItems="center" gap={1} mb={1}>
                                        <Typography variant="body2" color="textSecondary">
                                            Id:
                                        </Typography>
                                        <Typography variant="body2">
                                            {row.id}
                                        </Typography>
                                    </Box>
                                    <Box display="flex" alignItems="center" gap={1} mb={1}>
                                        <Typography variant="body2" color="textSecondary">
                                            Email:
                                        </Typography>
                                        <Typography variant="body2">
                                            {row.email}
                                        </Typography>
                                    </Box>
                                    <Box display="flex" alignItems="center" gap={1}>
                                        <Typography variant="body2" color="textSecondary">
                                            Telefone:
                                        </Typography>
                                        <Typography variant="body2">
                                            {row.phone}
                                        </Typography>
                                    </Box>
                                </CardContent>
                            </Card>
                        ))
                    )}
                </Box>


                <Box display={{ xs: 'none', sm: 'block' }} >
                    <Container>

                        <Box display={{ xs: 'none', sm: 'block' }}>
                            {loading.loadData ? (
                                <Box display='flex' justifyContent='center' alignItems='center' height='100%'>
                                    <CircularProgress size={20} />
                                </Box>
                            ) : (
                                <TableContainer component={Paper}>
                                    <Table sx={{ width: '100%', height: '100%', overflowY: 'auto' }} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Id</TableCell>
                                                <TableCell>Nome</TableCell>
                                                <TableCell>Email</TableCell>
                                                <TableCell>Telefone</TableCell>
                                                <TableCell align="right">Ações</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {rows.length > 0 ? (
                                                rows.map((row) => (
                                                    <TableRow
                                                        key={row.id}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell component="th" scope="row">
                                                            {row.id}
                                                        </TableCell>
                                                        <TableCell>{row.name}</TableCell>
                                                        <TableCell>{row.email}</TableCell>
                                                        <TableCell>{row.phone}</TableCell>
                                                        <TableCell align="right">
                                                            <IconButton
                                                                onClick={(event) => handleClick(event, row)}
                                                                size="small"
                                                            >
                                                                <MoreHorizIcon />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={5} align="center">
                                                        {loading.loadData ? (
                                                            <CircularProgress size={20} />
                                                        ) : (
                                                            'Nenhum usuário encontrado'
                                                        )}
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            )}
                        </Box>

                    </Container>
                </Box>
            </Layout >

            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                PaperProps={{
                    sx: {
                        minWidth: 120,
                        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
                    }
                }}
            >
                <MenuItem
                    onClick={() => handleEditUser(selectedUser)}
                    sx={{ py: 1 }}
                >
                    <ListItemIcon>
                        <EditIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Editar</ListItemText>
                </MenuItem>
                <MenuItem
                    sx={{ py: 1, color: 'error.main', p: 0 }}
                >
                    <ConfirmButton
                        title="Excluir Usuário"
                        message={`Tem certeza que deseja excluir o usuário "${selectedUser?.name}"? Esta ação não pode ser desfeita.`}
                        confirmText="Excluir"
                        cancelText="Cancelar"
                        confirmColor="error"
                        variant="text"
                        size="small"
                        onConfirm={() => handleDeleteUser(selectedUser)}
                        onCancel={handleClose}
                        sx={{
                            width: '100%',
                            justifyContent: 'flex-start',
                            color: 'error.main',
                            textTransform: 'none',
                            p: 1.5
                        }}
                    >
                        <Box display="flex" alignItems="center" className="gap-1">
                            <DeleteIcon />
                            <Typography>
                                Excluir
                            </Typography>
                        </Box>
                    </ConfirmButton>
                </MenuItem>
            </Popover>
        </>
    )
}